// import { Injectable } from '@angular/core';

// @Injectable({
//   providedIn: 'root'
// })
// export class UserPrivilegeService {

//   constructor() { }
// }

import { Injectable } from '@angular/core';
import { UserService } from './user.service';
import { UserInfoService } from './user-info.service';

@Injectable({
  providedIn: 'root'
})
export class UserPrivilegeService {
  privilegesByModule:string="";
  constructor(
    private userService : UserService,
    private userInfoService : UserInfoService,
  ) { }

  /*userPrivilegesByModule(module:any){
    console.log(module)
    let modulePrivileges:any;
    let userModulePrivileges:any;
     this.userService.getUserPrivileges().subscribe({
      next : (res:any) => {
        if(res) {
         console.log(res)
          const allUserPrivileges = res.result
          modulePrivileges = allUserPrivileges.filter((itm:any)=>itm.includes(module))
          let userModulePrivilegesArr = [];
          for(let i=0;i<modulePrivileges.length;i++){
            const parts = modulePrivileges[i].split("=>");
            userModulePrivilegesArr.push(parts[1]);
          }
          
          userModulePrivileges = userModulePrivilegesArr.join(',');
         //// console.log(userModulePrivileges);
          this.privilegesByModule = userModulePrivileges;
          return userModulePrivileges;
        }
        else {
        
        } 
      },error : (err:any) => {
  
        console.error("Error in fetching Privileges");
      }
      
    }
    )
   
  }

  privilegesMessage(module:any){


  }*/
  
  async userPrivilegesByModule(module: any) {
    let userModulePrivileges:any
    try {
      let userPrivileges:any
      if(!this.userInfoService.getPrivilegesFromSessionCache()){
      // const res = await this.userService.getUserPrivileges()
      let res:any
      let userType:any=  sessionStorage.getItem('loginUserType')
        userType=userType.toUpperCase()
      if(userType==='EMPLOYEE'){
        res = await this.userService.getUserTravellerPrivileges()
      }else{
       res = await this.userService.getUserPrivileges()
      }
    //  console.log(res)
      userPrivileges = res.result
      }
      userPrivileges = this.userInfoService.getPrivileges();
            // Your existing logic here...
             userModulePrivileges = this.userModulePrivileges(userPrivileges, module);
            return userModulePrivileges;  
        }catch (error) {
          console.error('Error fetching data:', error);
        }
        return userModulePrivileges;
  }
  
  userModulePrivileges(allUserPrivileges: any[], module: any): string {
    // Your existing logic to filter and transform the privileges
    let modulePrivileges = allUserPrivileges.filter((itm: any) => itm.includes(module));
    let userModulePrivilegesArr = [];
    for (let i = 0; i < modulePrivileges.length; i++) {
      const parts = modulePrivileges[i].split('=>');
      userModulePrivilegesArr.push(parts[1]);
    }
  
    let userModulePrivileges = userModulePrivilegesArr.join(',');
    return userModulePrivileges;
  }

  async userMenuPrivileges(): Promise<any>{
    try {
      let userPrivileges:any
      if(!this.userInfoService.getPrivilegesFromSessionCache()){
        let res:any
        let userType:any=  sessionStorage.getItem('loginUserType')
          userType=userType.toUpperCase()
        if(userType==='EMPLOYEE'){
          res = await this.userService.getUserTravellerPrivileges()
        }else{
         res = await this.userService.getUserPrivileges()
        }
     
      userPrivileges = res.result
      // console.log(userPrivileges)

      }
        
      userPrivileges = this.userInfoService.getPrivileges();
          // console.log(userPrivileges)
          let userMenuPrivilegesArr = [];
          // console.log(userPrivileges)
          for(let i=0;i<userPrivileges.length;i++){
            if(userPrivileges[i].includes("menu"))
            userMenuPrivilegesArr.push(userPrivileges[i].replace("menu=>",""));
          }
    //      console.log(userMenuPrivilegesArr);
          const userFinalMenu = this.userMenuJSONPrivileges(userMenuPrivilegesArr);
   //       console.log(userFinalMenu)
          return userFinalMenu;
        }
        catch (error) {
          console.error('Error fetching data:', error);
        }
        
  }
  userMenuJSONPrivileges(allUserMenuPrivileges: any[]): any {
   
    const menuMap:any = {};

  // Create a map of each menu item
  allUserMenuPrivileges.forEach(item => {
    const [parent, child] = item.split('=>');

    if (!menuMap[parent]) {
      menuMap[parent] = { label: parent, children: [] };
    }

    if (child) {
      menuMap[parent].children.push({ label: child });
    }
  });

  // Find the root items (items without parents)
  const rootItems = Object.values(menuMap).filter((item:any) => !item.parent);

  return rootItems;
}

}
